import { useMemo } from 'react'

import { form } from '../../formState'

import { useTexts } from './hooks/useTexts'

import { Divider } from '@/components/form/preview/layout/Divider'

type Option = {
  type: 'option'
  label: string
  value: 'OFF' | 'BACK_OFFICE'
}

export function CallbackConfigStatusField() {
  const texts = useTexts()
  const callbackConfigStatus = form.useFormField('callbackConfigStatus')
  const callbackConfigStatusVisible = callbackConfigStatus.field.visible

  const options: Option[] = useMemo(
    () => [
      { type: 'option', label: texts.callbackConfigStatus.values.off, value: 'OFF' },
      { type: 'option', label: texts.callbackConfigStatus.values.backOffice, value: 'BACK_OFFICE' },
    ],
    [texts],
  )

  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()
  const formDisabled = submitting || disabled

  return (
    <>
      {callbackConfigStatusVisible && <Divider />}
      <form.RadioGroup
        testId="voice-callback-config-status"
        options={options}
        name="callbackConfigStatus"
        validateOn="blur change"
        label={texts.callbackConfigStatus.label}
        disabled={formDisabled}
      />
    </>
  )
}
